"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var record_config_1 = __importDefault(require("./record.config"));
var RecordService = /** @class */ (function (_super) {
    __extends(RecordService, _super);
    function RecordService(BASE_URL, FUNCTIONS_KEY) {
        var _this = _super.call(this, BASE_URL, FUNCTIONS_KEY) || this;
        /**
         * API name: get-all-record-by-user
         */
        _this.getAllRecordById = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v1/get-all-available-record-by-user")];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        /**
         * API name: getVisitById
         */
        _this.getVisitById = function (id) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v1/get-visit-by-id?Id=".concat(id))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        /**
         * API name: getVisitOrAppointment
         */
        _this.getVisitOrAppointment = function (id) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v1/get-visit-or-appointment?Id=".concat(id))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        // /api/v1/get-visit-by-id
        /**
         * API name: get-complete-record
         */
        _this.getCompleteRecordById = function (id) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v1/get-complete-record?Id=".concat(id))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        // /api/v1/get-all-getAllNonAssistanceDocuments
        _this.getAllNonAssistanceDocuments = function (userId, prestacionId) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v2/user/".concat(userId, "/prestacion/").concat(prestacionId, "/documentosNoAsistenciales"))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        // /api/v1/get-management-document
        _this.getManagementDocument = function (userId, prestacionId, documentoId) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v2/user/".concat(userId, "/prestacion/").concat(prestacionId, "/documento/").concat(documentoId))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        //llamada a episodio Consulta
        _this.getEpisodeConsultation = function (userId, prestacionId) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v2/user/".concat(userId, "/prestacion/").concat(prestacionId, "/asistencial/episodios/ambulatorios"))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        //llamada a episodio Consulta por episodio Id
        _this.getEpisodeConsultationById = function (userId, prestacionId, episodioId) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v2/user/".concat(userId, "/prestacion/").concat(prestacionId, "/asistencial/episodios/ambulatorio/").concat(episodioId))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        //llamada a episodio Rehabilitación
        _this.getEpisodeRehabilitation = function (userId, prestacionId) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v2/user/".concat(userId, "/prestacion/").concat(prestacionId, "/asistencial/episodios/rehabilitaciones"))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        //llamada a episodio Hospitalization
        _this.getEpisodeHospitalization = function (userId, prestacionId) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v2/user/".concat(userId, "/prestacion/").concat(prestacionId, "/asistencial/episodios/hospitalizaciones"))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        //llamada a episodio Hospitalization por id
        _this.getEpisodeHospitalizationById = function (userId, prestacionId, episodioId) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v2/user/".concat(userId, "/prestacion/").concat(prestacionId, "/asistencial/episodios/hospitalizacion/").concat(episodioId))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        //llamada a episodio Quirofano
        _this.getEpisodeOperatingRoom = function (userId, prestacionId) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v2/user/".concat(userId, "/prestacion/").concat(prestacionId, "/asistencial/episodios/quirofanos"))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        //llamada a episodio Quirofano por id
        _this.getEpisodeOperatingRoomById = function (userId, prestacionId, episodioId) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v2/user/".concat(userId, "/prestacion/").concat(prestacionId, "/asistencial/episodios/quirofano/").concat(episodioId))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        //llamada a episodio Emergencies
        _this.getEpisodeEmergencies = function (userId, prestacionId) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v2/user/".concat(userId, "/prestacion/").concat(prestacionId, "/asistencial/episodios/urgencias"))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        //llamada a episodio Emergencies por id
        _this.getEpisodeEmergenciesbyId = function (userId, prestacionId, episodioId) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v2/user/".concat(userId, "/prestacion/").concat(prestacionId, "/asistencial/episodios/urgencia/").concat(episodioId))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        //llamada a episodio Images
        _this.getEpisodeImages = function (userId, prestacionId) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v2/user/".concat(userId, "/prestacion/").concat(prestacionId, "/asistencial/episodios/imagenes"))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        //llamada a episodio Images por id
        _this.getEpisodeImagesbyId = function (userId, prestacionId, episodioId) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v2/user/".concat(userId, "/prestacion/").concat(prestacionId, "/asistencial/episodios/imagen/").concat(episodioId))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        //llamada a episodio External Center
        _this.getEpisodeExternalCenter = function (userId, prestacionId) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v2/user/".concat(userId, "/prestacion/").concat(prestacionId, "/asistencial/episodios/centrosexternos"))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        //llamada a episodio External Center por id
        _this.getEpisodeExternalCenterId = function (userId, prestacionId, episodioId) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v2/user/".concat(userId, "/prestacion/").concat(prestacionId, "/asistencial/episodios/centroexterno/").concat(episodioId))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        // /api/v1/get-requestdocumentOtp
        _this.getRequestDocumentOtp = function (userId, prestacionId, documentoId) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v2/user/".concat(userId, "/prestacion/").concat(prestacionId, "/documento/").concat(documentoId, "/otp"))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        // /api/v1/get-request-document-Otp
        _this.getValidateDocumentOtp = function (userId, prestacionId, documentoId, otp) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v2/user/".concat(userId, "/prestacion/").concat(prestacionId, "/documento/").concat(documentoId, "/otp/").concat(otp))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        // getDocumentstByAppointmentId
        _this.getDocumentstByAppointmentId = function (userId, prestacionId, citaId) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v2/user/".concat(userId, "/prestacion/").concat(prestacionId, "/cita/").concat(citaId, "/documentos"))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        // getDocumentstByEpisodeId
        _this.getDocumentstByEpisodeId = function (userId, prestacionId, episodioId) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v2/user/".concat(userId, "/prestacion/").concat(prestacionId, "/episodio/").concat(episodioId, "/documentos"))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        // /api/v1/ getAllDocumentsWithOtp
        _this.getAllDocumentsWithOtp = function (userId, prestacionId) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v2/user/".concat(userId, "/prestacion/").concat(prestacionId, "/documentosConOtp"))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        // /api/v1/get-all-healthcare-document
        _this.getAllHealthcareDocument = function (userId, prestacionId) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v2/user/".concat(userId, "/prestacion/").concat(prestacionId, "/documentosAsistenciales"))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        // record for company
        _this.getCompleteRecordWithTdForCompany = function (id, userId) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v1/get-complete-record-with-td-for-company?Id=".concat(id, "&UserId=").concat(userId))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        _this.getCompleteRecordWithoutTdForCompany = function (id, userId) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v1/get-complete-record-without-td-for-company?Id=".concat(id, "&UserId=").concat(userId))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        _this.getCompleteRecordCataForCompany = function (id, userId) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v1/get-complete-record-cata-for-company?Id=".concat(id, "&UserId=").concat(userId))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        _this.getAllEconomicRecordForCompany = function (id, userId) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v1/get-all-economic-record-for-company?Id=".concat(id, "&UserId=").concat(userId))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        _this.getAllAdministrationRecordForCompany = function (id, userId) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v1/get-all-administration-record-for-company?Id=".concat(id, "&UserId=").concat(userId))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        _this.getEpisodeCompany = function (EpisodeId) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v1/get-episode-company?Id=".concat(EpisodeId))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        _this.getAllEpisodeCompany = function (RecordId) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v1/get-all-episode-company?RecordId=".concat(RecordId))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        _this.getInformationIAS = function (Id) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v1/get-informationIAS?Id=".concat(Id))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        _this.getAllInformationIAS = function (RecordId) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v1/get-all-informationIAS?RecordId=".concat(RecordId))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        _this.getHealthcareDocumentForCompany = function (DocumentId) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v1/get-healthcare-document-for-company?Id=".concat(DocumentId))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        // FOTMULARIOS REAL DECRETO
        _this.getRoyalDecreeForms = function (userId, prestacionId) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v2/user/".concat(userId, "/prestacion/").concat(prestacionId, "/formularios"))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        _this.getRoyalDecreeFormsCount = function (userId) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api//v2/user/".concat(userId, "/formularios-rd-count"))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        _this.getRoyalDecreeFormById = function (userId, prestacionId, id) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v2/user/".concat(userId, "/prestacion/").concat(prestacionId, "/formulario-rd/").concat(id))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        _this.getRoyalDecreeFormManual = function (type) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v2/formulario-manual/".concat(type))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        _this.updateIncompatibilityDocuments = function (userId, prestacionId, formId, docId, data) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.put("api/v2/user/".concat(userId, "/prestacion/").concat(prestacionId, "/formulario-rd/").concat(formId, "/documento/").concat(docId), data)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        // formulario pago-directo-it
        _this.getDirectPaymentFormsItByUser = function (userId) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v2/user/".concat(userId, "/formularios-pago-directo-it"))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        _this.getDirectPaymentFormItByID = function (userId, prestacionId, id) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v2/user/".concat(userId, "/prestacion/").concat(prestacionId, "/formulario-pago-directo-it/").concat(id))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        _this.updateDirectPaymentFormItByID = function (userId, prestacionId, formId, data) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.put("/api/v2/user/".concat(userId, "/prestacion/").concat(prestacionId, "/formulario-pago-directo-it/").concat(formId), data)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        _this.newDirectPaymentFormIt = function (userId, prestacionId, data) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.post("/api/v2/user/".concat(userId, "/expediente/").concat(prestacionId, "/formulario-pago-directo-it"), data)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        _this.getInfoDirectPaymentFormIt = function (userId) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v2/user/".concat(userId, "/info-formulario-pago-directo-it"))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        //formulario modelo145
        _this.getModelo145ItByUser = function (userId) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v2/user/".concat(userId, "/formularios-modelo-145"))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        _this.getModelo145ItByID = function (userId, prestacionId, id) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v2/user/".concat(userId, "/prestacion/").concat(prestacionId, "/formulario-modelo-145/").concat(id))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        _this.updateModelo145ItByID = function (userId, prestacionId, formId, data) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.put("/api/v2/user/".concat(userId, "/prestacion/").concat(prestacionId, "/formulario-modelo-145/").concat(formId), data)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        _this.newModelo145It = function (userId, prestacionId, data) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.post("/api/v2/user/".concat(userId, "/expediente/").concat(prestacionId, "/formulario-modelo-145"), data)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        _this.getInfoModelo145It = function (userId) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v2/user/".concat(userId, "/info-formulario-modelo-145"))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        //Formulario Declaracion Situacion Actividad
        _this.getDeclaracionSituacionActividadItByUser = function (userId) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v2/user/".concat(userId, "/formularios-declaracion-situacion-actividad"))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        _this.getDeclaracionSituacionActividadItByID = function (userId, prestacionId, id) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v2/user/".concat(userId, "/prestacion/").concat(prestacionId, "/formulario-declaracion-situacion-actividad/").concat(id))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        _this.updateDeclaracionSituacionActividadItByID = function (userId, prestacionId, formId, data) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.put("/api/v2/user/".concat(userId, "/prestacion/").concat(prestacionId, "/formulario-declaracion-situacion-actividad/").concat(formId), data)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        _this.newDeclaracionSituacionActividadIt = function (userId, prestacionId, data) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.post("/api/v2/user/".concat(userId, "/expediente/").concat(prestacionId, "/formulario-declaracion-situacion-actividad"), data)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        _this.getInfoDeclaracionSituacionActividadIt = function (userId) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v2/user/".concat(userId, "/info-formulario-declaracion-situacion-actividad"))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        return _this;
    }
    return RecordService;
}(record_config_1.default));
exports.default = RecordService;
